import { useState, useEffect } from 'react';

export interface ProjectTask {
  id: string;
  index: string;
  name: string;
  location: string;
  category: string;
  categoryColor: string;
  assignee: {
    name: string;
    avatar: string;
  };
  startDate: string;
  endDate: string;
  progress: number;
  status: string;
  statusColor: string;
  priority: string;
  priorityColor: string;
}

export function useProjectTasks() {
  const [tasks, setTasks] = useState<ProjectTask[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Giả lập fetch data từ Supabase theo đúng schema
    const timer = setTimeout(() => {
      setTasks([
        {
          id: '0',
          index: '00',
          name: 'Lập hồ sơ thiết kế bản vẽ thi công',
          location: 'Văn phòng',
          category: 'Hồ sơ',
          categoryColor: 'bg-blue-50 text-blue-600',
          assignee: { name: 'Nguyễn Thị Lan', avatar: 'https://i.pravatar.cc/150?u=5' },
          startDate: '25/03/2024',
          endDate: '31/03/2024',
          progress: 100,
          status: 'Hoàn thành',
          statusColor: 'bg-emerald-50 text-emerald-600',
          priority: 'Cao',
          priorityColor: 'bg-rose-50 text-rose-600'
        },
        {
          id: '0.1',
          index: '00.1',
          name: 'Phê duyệt phương án thi công & biện pháp an toàn',
          location: 'Văn phòng',
          category: 'Hồ sơ',
          categoryColor: 'bg-blue-50 text-blue-600',
          assignee: { name: 'Trần Minh Tuấn', avatar: 'https://i.pravatar.cc/150?u=1' },
          startDate: '28/03/2024',
          endDate: '05/04/2024',
          progress: 80,
          status: 'Đang thực hiện',
          statusColor: 'bg-blue-50 text-blue-600',
          priority: 'Cao',
          priorityColor: 'bg-rose-50 text-rose-600'
        },
        {
          id: '0.2',
          index: '00.2',
          name: 'Chuẩn bị hồ sơ năng lực nhân sự & bảo hiểm',
          location: 'Văn phòng',
          category: 'Hồ sơ',
          categoryColor: 'bg-blue-50 text-blue-600',
          assignee: { name: 'Lê Thị Hồng', avatar: 'https://i.pravatar.cc/150?u=6' },
          startDate: '01/04/2024',
          endDate: '10/04/2024',
          progress: 40,
          status: 'Đang thực hiện',
          statusColor: 'bg-blue-50 text-blue-600',
          priority: 'Trung bình',
          priorityColor: 'bg-amber-50 text-amber-600'
        },
        {
          id: '1',
          index: '01',
          name: 'San nền và chuẩn bị mặt bằng',
          location: 'Khu A - San nền',
          category: 'San nền',
          categoryColor: 'bg-emerald-50 text-emerald-600',
          assignee: { name: 'Trần Minh Tuấn', avatar: 'https://i.pravatar.cc/150?u=1' },
          startDate: '01/04/2024',
          endDate: '10/04/2024',
          progress: 100,
          status: 'Hoàn thành',
          statusColor: 'bg-emerald-50 text-emerald-600',
          priority: 'Cao',
          priorityColor: 'bg-rose-50 text-rose-600'
        },
        {
          id: '2',
          index: '02',
          name: 'Trồng cây xanh',
          location: 'Khu A - Cây xanh',
          category: 'Cây xanh',
          categoryColor: 'bg-emerald-50 text-emerald-600',
          assignee: { name: 'Lê Hoàng Nam', avatar: 'https://i.pravatar.cc/150?u=2' },
          startDate: '11/04/2024',
          endDate: '20/05/2024',
          progress: 70,
          status: 'Đang thực hiện',
          statusColor: 'bg-blue-50 text-blue-600',
          priority: 'Trung bình',
          priorityColor: 'bg-amber-50 text-amber-600'
        },
        {
          id: '3',
          index: '03',
          name: 'Lắp đặt hệ thống tưới tự động',
          location: 'Khu A - Hệ thống tưới',
          category: 'Hệ thống tưới',
          categoryColor: 'bg-blue-50 text-blue-600',
          assignee: { name: 'Phạm Văn Tài', avatar: 'https://i.pravatar.cc/150?u=3' },
          startDate: '15/04/2024',
          endDate: '25/05/2024',
          progress: 30,
          status: 'Đang thực hiện',
          statusColor: 'bg-blue-50 text-blue-600',
          priority: 'Cao',
          priorityColor: 'bg-rose-50 text-rose-600'
        },
        {
          id: '4',
          index: '04',
          name: 'Hệ thống chiếu sáng',
          location: 'Khu A - Chiếu sáng',
          category: 'Chiếu sáng',
          categoryColor: 'bg-purple-50 text-purple-600',
          assignee: { name: 'Nguyễn Văn An', avatar: 'https://i.pravatar.cc/150?u=4' },
          startDate: '20/05/2024',
          endDate: '15/06/2024',
          progress: 0,
          status: 'Chưa bắt đầu',
          statusColor: 'bg-slate-100 text-slate-500',
          priority: 'Trung bình',
          priorityColor: 'bg-amber-50 text-amber-600'
        },
        {
          id: '5',
          index: '05',
          name: 'Tiểu cảnh & hồ nước',
          location: 'Khu A - Tiểu cảnh',
          category: 'Tiểu cảnh',
          categoryColor: 'bg-orange-50 text-orange-600',
          assignee: { name: 'Lê Hoàng Nam', avatar: 'https://i.pravatar.cc/150?u=2' },
          startDate: '16/06/2024',
          endDate: '30/07/2024',
          progress: 0,
          status: 'Chưa bắt đầu',
          statusColor: 'bg-slate-100 text-slate-500',
          priority: 'Thấp',
          priorityColor: 'bg-slate-50 text-slate-400'
        }
      ]);
      setIsLoading(false);
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  return { tasks, isLoading };
}
